import { tokens } from '@sail/ui';
import { helmTokens } from '../tokens/helmTokens';
export const whiteSailColorTokens = {
    icon: {
        $default: tokens.color.neutral[900],
        emphasized: tokens.color.neutral[900]
    },
    text: {
        $default: tokens.color.neutral[700],
        emphasized: tokens.color.neutral[900],
        subdued: tokens.color.neutral[500],
        action: {
            primary: {
                $default: helmTokens.color.accentColor,
                hovered: tokens.color.neutral[900]
            },
            secondary: {
                $default: tokens.color.neutral[900],
                hovered: 'rgba(10, 37, 64, 0.6)'
            }
        },
        onAction: {
            primary: {
                pressed: tokens.color.brand[0]
            },
            // secondary is our "Link" style for CtaButton
            // this could be a problem if we have a secondary action
            // tokens are used elsewhere but good for now
            secondary: {
                $default: helmTokens.color.accentColor,
                hovered: tokens.color.neutral[900],
                pressed: tokens.color.neutral[800]
            }
        },
        form: {
            $default: tokens.color.neutral[800],
            hovered: tokens.color.neutral[900],
            placeholder: tokens.color.neutral[500]
        }
    },
    background: {
        surface: tokens.color.neutral[0],
        offset: tokens.color.neutral[0],
        action: {
            primary: {
                $default: helmTokens.color.accentColor,
                hovered: tokens.color.neutral[900],
                pressed: tokens.color.neutral[800]
            },
            secondary: {
                $default: 'transparent',
                hovered: 'transparent',
                pressed: 'transparent'
            }
        },
        form: {
            $default: tokens.color.neutral[100],
            accent: tokens.color.brand[600]
        }
    },
    border: {
        action: {
            primary: {
                $default: helmTokens.color.accentColor,
                hovered: tokens.color.neutral[900],
                pressed: 'transparent'
            }
        },
        form: 'transparent'
    }
};
export const whiteHelmColorTokens = {
    gridLines: {
        dashed: 'rgba(66, 71, 112, 0.09)',
        solid: 'rgba(66, 71, 112, 0.06)'
    },
    annotationColor: '#8c9eb1',
    navColor: tokens.color.neutral[900],
    navHoverColor: tokens.color.neutral[900],
    navHoverOpacity: '0.6',
    cardBorderColor: tokens.color.neutral[300],
    subcardBackground: tokens.color.neutral[100],
    /* Background for Cards/Highlighted content in the grid and without shadows */ gridSubcardBackground: tokens.color.neutral[0],
    tableIconColor: '#8c9eb1',
    stripeAccentLight: tokens.color.neutral[200],
    bulletColor: tokens.color.neutral[300],
    disclaimerTextColor: tokens.color.neutral[500],
    inlineCodeTextColor: tokens.color.neutral[800],
    inlineCodeBackground: '#dce6ee',
    socialLogoColor: tokens.color.neutral[300],
    socialLogoHoverColor: tokens.color.neutral[900],
    customerLogoColor: tokens.color.neutral[400]
};

//# sourceMappingURL=White.js.map